<template>
  <div
      id="widgets-drawer"
      class="bg-body drawer drawer-end"
      data-kt-drawer="true"
      data-kt-drawer-name="chat"
      data-kt-drawer-activate="true"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction="end"
      data-kt-drawer-toggle="#widgets-drawer-btn"
      data-kt-drawer-close="#widgets-drawer-close"
     >
    <div class="card w-100 overflow-hidden rounded-0 border-0" id="kt_drawer_chat_messenger">
      <div class="card-header pe-5" id="kt_drawer_chat_messenger_header">
        <div class="card-title">
          <h3> {{ $t('stats.widgetsList') }} </h3>
        </div>
        <div class="card-toolbar">
          <div class="btn btn-sm btn-icon" id="widgets-drawer-close">
            <span class="svg-icon svg-icon-2">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
									<rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
									<rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
								</svg>
							</span>
          </div>
        </div>
      </div>

      <div class="card-body px-4" id="kt_drawer_chat_messenger_body">
        <div id="notification-list-container" :class="{'scroll-y' : widgets.length > 0 }" class="me-n5 pe-5" data-kt-element="messages"
             data-kt-scroll="true"
             data-kt-scroll-activate="true"
             data-kt-scroll-height="auto"
             data-kt-scroll-dependencies="#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer"
             data-kt-scroll-wrappers="#kt_drawer_chat_messenger_body" data-kt-scroll-offset="0px"
             style="height: 90vh"
             >

          <div class="d-flex flex-column mb-10">
            <div class="d-flex flex-column flex-grow-1 m-2">
              <div  v-if="!widgets.length" class="text-center fs-3"> {{  $t('notification.empty') }}</div>
              <div class="p-5 row ">
                  <div class="col-6 mb-5" v-for="widget in widgets" :key="widget?.id">
                      <WidgetNameCard :widget="widget" @click="handleSelected(widget?.id)" :isSelected="isWidgetSelected(widget?.id).value"/>
                  </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-if="isLoading">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">{{ $t("loadingText") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <WidgetSizeModal id="kt_widget_sized" :img="img" :widget="model" @closed="resetForm"/>

</template>

<script setup>


import {computed, nextTick, onMounted, reactive, ref, watch, watchEffect} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import WidgetNameCard from "./WidgetNameCard.vue";
import WidgetSizeModal from "./WidgetSizeModal.vue";

const props = defineProps(
  {
    id:{type: String, default: "kt_widgets_modal"},
})

const store = useStore()
const router = useRouter()
const model = defineModel()

const currentPage = computed(() => store.getters['notifications/currentPage'] )
const lastPage = computed(() => store.getters['notifications/lastPage'] )
const isLoading = ref(false)
const img = ref('')

const widgets = computed(() => store.getters['stats/getWidgets'])
const addedWidgets = computed(() => store.getters['stats/getAddedWidgets'])
const addedIds = computed(() => new Set(addedWidgets.value?.map(el => el?.id)))

const isWidgetSelected = (id) => {
  return computed(() => model.value === id || addedIds.value.has(id))
}


const handleSelected = (id) => {
    img.value = widgets.value?.find(el => el.id == id)?.type['img']
    model.value = id
}

const resetForm = () => {
    model.value = null
    img.value = null
}

watch(() => model.value, () => {
    if(model.value){
        openWidgetSizing()
    }
})

const openWidgetSizing = () => {
    $("#kt_widget_sized").modal('toggle')
}

const drawerElement = ref(null);
const drawer = ref(null);

function initDrawer() {
  nextTick(() => {
    drawerElement.value = document.querySelector("#widgets-drawer");
    if (drawerElement.value) {
      drawer.value =  KTDrawer.getInstance(drawerElement.value);
      drawer.value?.on("kt.drawer.show", function() {
        document.querySelectorAll('.drawer-overlay').forEach(el => el.remove());
        store.dispatch('notifications/openedNotifications')
      });
    }
  });
}

watchEffect(() => {
  initDrawer();
});


onMounted(async () => {
  await KTDrawer.init();
  initDrawer();
})

</script>

<style scoped>

</style>